import { AddressT, EmployeeCountT, ManagementT as ManagerT, UrlT } from "ui-io/company-io";
import * as t from "io-ts";
import {TABS,TAG,CATEGORY,BADGE,INDUSTRY} from 'ui-io/common-io'
import { MARKET_CAP, SIC } from "./admin-io";

const createOptionsObj = <T extends Record<string, string>>(obj: T) =>
  Object.entries(obj).map(([value, label]) => ({
    label,
    value,
  }));

export const TAG_OPTIONS_OBJ = createOptionsObj(TAG);
export const INDUSTRY_OPTIONS_OBJ = createOptionsObj(INDUSTRY);
export const CATEGORY_OPTIONS_OBJ = createOptionsObj(CATEGORY);
export const BADGE_OPTIONS_OBJ = createOptionsObj(BADGE);
export const MARKET_CAP_OPTIONS_OBJ = createOptionsObj(MARKET_CAP);
export const SIC_CODE_OBJ = createOptionsObj(SIC);

export const IndustryIO = t.keyof(INDUSTRY);
export const CompanyTagIO = t.keyof(TAG);
export const BadgeTagIO = t.keyof(BADGE);
export const MarketCapIO = t.keyof(MARKET_CAP);

export type IndustryTagT = t.TypeOf<typeof IndustryIO>;
export type CompanyTagT = t.TypeOf<typeof CompanyTagIO>;
export type BadgeTagT = t.TypeOf<typeof BadgeTagIO>;

export type AddressTypeT =
  | "REGISTERED"
  | "HEADQUATER"
  | "SERVICE"
  | "BUSINESS"
  | "CORPORATE"
  | "BRANCH"
  | "OPERATIONS"
  | "MANUFACTURING"
  | "RESEARCH AND DEVELOPMENT"
  | "DISTRIBUTION"
  | "WAREHOUSE"
  | "ADMINISTRATIVE"
  | "SALES"
  | "CUSTOMER SUPPORT"
  | "TECHNICAL SUPPORT";

export type KeyAndRegexT = {
  date: string;
  share_holder: string;
  share_class: string;
  currency: string;
  number_of_share: string;
  aggregate_nominal_value: string;
  prescribed_class: string;
};

export type ShareAllotmentT = {
  schedule: { cron: string };
  next_run?: number;
  url: string;
  response_key: string;
  statement_type: "cs01" | "sh01";
  base_regex: string;
  key_and_regex: KeyAndRegexT;
};

export type ManagementKeyAndRegexT = {
  name: string;
  address: string;
  dob: string;
  appointed: string;
  position: string;
  occupation: string;
  status: string;
  residence: string;
  nationality: string;
};

export type ManagementT = {
  schedule: { cron: string };
  next_run?: number;
  response_key: string;
  base_regex: string;
  key_and_regex: ManagementKeyAndRegexT;
  url: string;
};
export type IndustryT = {
  sic_code: string;
  lsic_code: string;
  industry: IndustryTagT;
  sub_industry: string;
  market_cap?: string;
  category: string[];
};
export type TransformedCompanyT = {
  name: string;
  company_type: string;
  licence_no: string;
  description: string;
  status: string;
  incorporation_date: string;
  industry: {
    sic_code: string;
    lsic_code: string;
  };
  address: Array<{
    full_address: string;
    street: string;
    city: string;
    state: string;
    country: string;
    postal_code: string;
    type: string;
  }>;
  url: {
    website: string;
    logo: string;
    linkedin: string;
    twitter: string;
  };
};

export type CompanyDetailT = {
  companyID: string;
  name: string;
  description: string;
  business_description: string;
  traction: Record<string,string>[];
  company_no: string;
  licence_no: string;
  emp_count: EmployeeCountT[];
  status: string;
  company_type: string;
  incorporation_date: string;
  share_allotment: { cs01: any; sh01: any };
  industry: IndustryT;
  url: UrlT;
  addresses: AddressT[];
  management: ManagerT;
  tags: CompanyTagT[];
  badges: BadgeTagT[];
};

export type FormDataT = {
  companyDetail: CompanyDetailT;
  configDetail: {
    companyID: string;
    licence_no: string;
    name: string;
    status: string;
    management: ManagementT;
    share_allotment: ShareAllotmentT[];
  };
};
export type TableCompanyDataT = {
  company_name: string;
  company_number: string;
  company_status: string;
  company_type: string;
  company_subtype: string;
  dissolution_date: string;
  incorporation_date: string;
  removed_date: string;
  registered_date: string;
  nature_of_business: string;
  registered_office_address: string;
};

export const scheduleOptions = [
  { label: "Once", value: "Today" },
  { label: "Weekly", value: "Weekly" },
  { label: "Monthly", value: "Monthly" },
  { label: "Quarterly", value: "Quarterly" },
  { label: "Yearly", value: "Yearly" },
  { label: "Custom", value: "Custom" },
];

export const defaultData: FormDataT = {
  companyDetail: {
    companyID: "",
    name: "",
    status: "",
    company_no: "",
    licence_no: "",
    emp_count: [],
    company_type: "",
    incorporation_date: "",
    description: "",
    business_description: "",
    traction: [],
    tags: [],
    badges: [],
    addresses: [
      {
        full_address: "",
        street: "",
        city: "",
        state: "",
        country: "",
        postal_code: "",
        type: "REGISTERED",
      },
    ],
    management: {
      name: "",
      email: "",
      phone: "",
      position: "",
      linkedin: "",
    },
    share_allotment: {
      cs01: [],
      sh01: [],
    },
    industry: {
      sic_code: "",
      lsic_code: "",
      industry: "ADTECH",
      sub_industry: "",
      // category: "",
      market_cap: "",
      category: [],
    },
    url: {
      website: "",
      logo: "",
      linkedin: "",
      twitter: "",
    },
  },
  configDetail: {
    companyID: "",
    licence_no: "",
    name: "",
    status: "",

    share_allotment: [
      {
        schedule: { cron: "" },
        next_run: 0,
        url: "",
        response_key: "",
        base_regex: "",
        statement_type: "cs01",
        key_and_regex: {
          date: "",
          share_holder: "",
          share_class: "",
          currency: "",
          number_of_share: "",
          aggregate_nominal_value: "",
          prescribed_class: "",
        },
      },
      {
        schedule: { cron: "" },
        next_run: 0,
        url: "",
        response_key: "",
        base_regex: "",
        statement_type: "sh01",
        key_and_regex: {
          date: "",
          share_holder: "",
          share_class: "",
          currency: "",
          number_of_share: "",
          aggregate_nominal_value: "",
          prescribed_class: "",
        },
      },
    ],
    management: {
      schedule: { cron: "" },
      next_run: 0,
      response_key: "",
      base_regex: "",
      key_and_regex: {
        name: "",
        address: "",
        dob: "",
        appointed: "",
        position: "",
        occupation: "",
        status: "",
        residence: "",
        nationality: "",
      },
      url: "",
    },
  },
};
